if (!window.customElements.get('bundle-form')) {
  class BundleForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-bundle-form]');
      this.formSubmitButton = this.querySelector('[data-bundle-form-submit]');
      this.bundleProducts = this.querySelectorAll('product-buybox');
      this.quantityAmount = this.querySelector('[data-quantity-input]');
      this.soldoutBundleProducts = false;
      this.selectedOptions = this.querySelectorAll('[data-text-option].selected');
      this.stickyAtc = this.closest('[data-product')?.querySelector('product-sticky-atc');
      this.buyBoxes = this.querySelectorAll('product-buybox');

      if (!this.form || !this.formSubmitButton) return;

      this.updateQuantityInput();
      this.removeInitialSelection();
      this.updateFormSubmitButton();
      this.bundleProductObserver();
      this.form.addEventListener('submit', (event) => this.submitForm(event));

      this.bundleProducts.forEach((bundleProduct) => {
        bundleProduct.addEventListener('variantOptionsChanged', (event) => {
          this.updateImage(bundleProduct, event.detail);
          this.updateConstructorTracking();
        });
      });

      setTimeout(() => this.validateSelectedOptions(), 1000);
    }

    updateConstructorTracking() {
      if (window.cnstrc?.supplementsPdpData?.items?.length >= 1) {
        const items = [];

        this.buyBoxes.forEach((buyBox) => {
          items.push({
            item_id: buyBox.hasAttribute('data-product-id') ? buyBox.getAttribute('data-product-id') : null,
            variation_id: buyBox.hasAttribute('data-selected-variant-id') ? buyBox.getAttribute('data-selected-variant-id') : null,
            price: buyBox.hasAttribute('data-selected-variant-price') ? Number(buyBox.getAttribute('data-selected-variant-price')) : null,
          });
        });

        window.cnstrc.supplementsPdpData.items = items;
      }
    }

    validateSelectedOptions() {
      this.selectedOptions.forEach((option) => {
        if (option && option.classList.contains('unavailable')) {
          const parentBuyBox = option.closest('product-buybox');

          if (parentBuyBox) {
            parentBuyBox.classList.add('soldout');
          }
        }
      });
    }

    updateImage(bundleProduct, details) {
      const image = bundleProduct.querySelector('[data-bundle-form-image]');
      if (!image || !details.variant?.variant_image_src) return;
      image.setAttribute('src', details.variant.variant_image_src);
      image.setAttribute('srcset', details.variant.variant_image_src);
      image.setAttribute('alt', details.variant.variant_image_alt || '');
    }

    updateQuantityInput() {
      const bundleProductQuantities = Array.from(this.bundleProducts).map((bundleProduct) => parseInt(bundleProduct.getAttribute('data-max-quantity')));
      const maxQuantity = Math.min(...bundleProductQuantities);

      if (this.quantityAmount) {
        this.quantityAmount.setAttribute('max', maxQuantity);

        if (this.quantityAmount.value > maxQuantity) {
          this.quantityAmount.value = maxQuantity;
        }
      }
    }

    bundleProductObserver() {
      this.bundleProducts.forEach((bundleProduct) => {
        const observer = new MutationObserver(() => {
          this.updateQuantityInput();
          this.updateFormSubmitButton();
        });
        observer.observe(bundleProduct, { attributes: true });
      });
    }

    removeInitialSelection() {
      const optionGroupLabels = this.querySelectorAll('[data-option-group-label]');
      const options = this.querySelectorAll('[data-option]');
      optionGroupLabels.forEach((label) => label.innerText = '');
      options.forEach((option) => option.classList.remove('selected', 'unavailable'));
    }

    validateOptionSelection() {
      const optionGroups = this.querySelectorAll('[data-option-group]');
      const selectedOptions = this.querySelectorAll('[data-option].selected');
      return selectedOptions && selectedOptions.length >= optionGroups.length;
    }

    updateFormSubmitButton() {
      const soldoutProducts = Array.from(this.bundleProducts).find((bundleProduct) => bundleProduct.classList.contains('soldout'));
      const optionsSelected = this.validateOptionSelection();

      if (!optionsSelected) {
        this.formSubmitButton.setAttribute('disabled', '');
        this.formSubmitButton.innerText = this.formSubmitButton?.getAttribute('data-choose-options-text') ?? 'Choose Options';
      } else if (soldoutProducts) {
        this.formSubmitButton.setAttribute('disabled', '');
        this.formSubmitButton.innerText = this.formSubmitButton?.getAttribute('data-soldout-text') ?? 'Sold out';
      } else {
        this.formSubmitButton.removeAttribute('disabled');
        this.formSubmitButton.innerText = this.formSubmitButton?.getAttribute('data-available-text') ?? 'Add to cart';
      }
    }

    submitForm(event) {
      event.preventDefault();

      this.updateSubmitButton(this.formSubmitButton.getAttribute('data-adding-text'), true);

      const bundleParentIdInput = this.querySelector('[data-bundle-parent-id]');
      const quantityInput = this.querySelector('[data-quantity-input]');
      const bundleId = crypto.randomUUID();

      const postBody = {
        items: []
      }

      this.bundleProducts.forEach((bundleProduct) => {
        const bundleProductId = bundleProduct.querySelector('[data-variant-id]')?.value;

        if(!bundleProductId) return;

        postBody.items.push({
          id: bundleProductId,
          quantity: quantityInput.value || 1,
          properties: {
            _bundle_id: bundleId,
            _bundle_child: true,
            _bundle: this.getAttribute('data-bundle-name'),
            _bundle_discount: this.getAttribute('data-bundle-discount'),
          }
        })
      });

      postBody.items.push({
        id: bundleParentIdInput.value,
        quantity: quantityInput.value || 1,
        properties: {
          _bundle_id: bundleId,
          _bundle_parent: true,
          _original_price: this.getAttribute('data-original-price')
        }
      });

      fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(postBody),
        credentials: 'same-origin'
      }).then((response) => {
        if (response.ok) {
          const sideCart = document.querySelector('side-cart');

          this.updateSubmitButton(this.formSubmitButton.getAttribute('data-success-text'), false);

          this.bundleProducts[0].updateCartBubbles();

          if (sideCart) {
            sideCart.renderContents();
          }

          setTimeout(() => {
            this.updateSubmitButton(this.formSubmitButton.getAttribute('data-available-text'), false);

            if (sideCart) {
              sideCart.open();
            }
          }, 1500);
        } else {
          return response.json().then((err) => {
            console.error('Cart add error:', err);
            this.updateSubmitButton(this.formSubmitButton.getAttribute('data-error-text'), true);

            setTimeout(() => {
              this.resetSubmitButton();
            }, 1500);
          });
        }
      }).catch((error) => {
        console.error(error);

        this.updateSubmitButton(this.formSubmitButton.getAttribute('data-error-text'), true);

        setTimeout(() => {
          this.resetSubmitButton();
        }, 1500);
      })
    }

    updateSubmitButton(text, disabled) {
      if (this.formSubmitButton) {
        this.formSubmitButton.textContent = text;
        this.formSubmitButton.disabled = disabled;

        if (disabled) {
          this.formSubmitButton.setAttribute('aria-disabled', 'true');
        } else {
          this.formSubmitButton.removeAttribute('aria-disabled');
        }
      }

      if (this.stickyAtc) {
        this.stickyAtc.updateSubmitButton(text, disabled);
      }
    }

    resetSubmitButton() {
      this.updateSubmitButton(this.formSubmitButton.getAttribute('data-available-text'), false);
    }
  }

  window.customElements.define('bundle-form', BundleForm);
}